import { getPortionUnits } from '../../state/foodLibrary'
import {useEffect,useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import Select from 'react-select'

const PortionUnitSelect = ({portionUnit,onChange})=>{
  const dispatch = useDispatch()
  useEffect(()=>{
    dispatch(getPortionUnits())
  },[])

  const portionUnits = (
    [...useSelector(state=>state.foodLibrary.portionUnits)]
    .sort((a,b)=>{
      const lengthVal = a.unit.length - b.unit.length
      const alphabetical = a.unit < b.unit ? -1 : 1
      if(lengthVal === 0) return alphabetical
      return lengthVal
    })
    .map(({id,unit})=>({label:unit,value:id}))
  )

  const [val,setVal] = useState(null)
  const [query,setQuery] = useState('')

  useEffect(()=>{
    if(portionUnits.length===0) return 
    setVal(portionUnits.find(u=>u.value === portionUnit))
  },[portionUnit])
  const singleLetterUnits = ['g']

  return (
     <Select 
      value={val}
      onChange={onChange}
      onInputChange={setQuery}
      className="w-50"
      options={portionUnits}
      noOptionsMessage={()=>"Search units"}
    />
  )
}

export default PortionUnitSelect